<template>
  <div class="page-column">
    <h2>运动员审核名单</h2>
    <a-table :columns="columns" :data-source="data" :pagination="false" bordered>
      <template slot="name" slot-scope="text">
        <a>{{ text }}</a>
      </template>
      <template slot="title" slot-scope="currentPageData">
        搜索：<a-input-search placeholder="请输入名字或者身份证搜索" style="width: 300px" @search="onSearch" />
        <a-input-search placeholder="请输入单位名字搜索" style="width: 300px" @search="onAgencySearch" />
        <a-radio-group @change="changeStatus" v-model="valData.status" style="margin-bottom: 16px">
          <a-radio-button :value="-1">
            全部
          </a-radio-button>
          <a-radio-button :value="0">
            未审核
          </a-radio-button>
          <a-radio-button :value="1">
            审核通过
          </a-radio-button>
          <a-radio-button :value="2">
            审核未通过
          </a-radio-button>
        </a-radio-group>
        <a-pagination style="float: right;" v-if="data.length > 0" v-model="current" @change="pageData" :total="total" :pageSize="valData.pageSize" show-less-items />
      </template>
      <template slot="sex" slot-scope="text, record">
        <a-tag v-if="text === 2" color="pink">女</a-tag>
        <a-tag v-if="text === 1" color="blue">男</a-tag>
      </template>
      <template slot="combatList" slot-scope="text, record">
        <a-button type="primary" @click="$refs.showPlayer.show(record)" shape="circle" icon="search" />
        <!-- <template v-if="text.length > 0">
          参赛项目：<a-tag color="blue" v-for="(it,ind) in text" :key="ind">{{ it.combat === null ? it.title : it.combat }}</a-tag>
        </template> -->
        <!-- <template v-if="record.major">专业：{{ record.major }}&ensp;&ensp;</template>
        <template v-if="record.studentId">学号：{{ record.studentId }}&ensp;&ensp;</template>
        <template v-if="record.mobile">联系电话：{{ record.mobile }}&ensp;&ensp;</template>
        <template v-if="record.enrollmentDate">入学时间：{{ record.enrollmentDate }}&ensp;&ensp;</template>
        <template v-if="record.educational">学历：{{ record.educational }}&ensp;&ensp;</template>
        <template v-if="record.graduationDate">预计毕业时间：{{ record.graduationDate }}</template><br/>
        <template v-if="record.validateImg">学信网学籍验证报告：<a :href="record.validateImg" target="_blank"><img :src="record.validateImg" style="width:32px;height:32px;"></a></template>
        <template v-if="record.noticeImg">入学通知书（新生）：<a :href="record.noticeImg" target="_blank"><img :src="record.noticeImg" style="width:32px;height:32px;"></a></template>
        <template v-if="record.cardImg">身份证照片：<a :href="record.cardImg" target="_blank"><img :src="record.cardImg" style="width:32px;height:32px;"></a></template>
        <template v-if="record.recordImg">录检表（新生）：<a :href="record.recordImg" target="_blank"><img :src="record.recordImg" style="width:32px;height:32px;"></a></template>
        <template v-if="record.graduateImg">本科学籍证明(研究生)：<a :href="record.graduateImg" target="_blank"><img :src="record.graduateImg" style="width:32px;height:32px;"></a></template>
        <template v-if="record.undergraduateImg">专科学籍证明(专升本)：<a :href="record.undergraduateImg" target="_blank"><img :src="record.undergraduateImg" style="width:32px;height:32px;"></a></template> -->
      </template>
      <template slot="status" slot-scope="text, record">
        <a-tag v-if="record.isFinals == 1">总决赛</a-tag>
        <a-tag v-else>分站赛</a-tag>
        <a-tag v-if="text === 0">未审核</a-tag>
        <a-tag v-if="text === 1" color="#87d068">通过</a-tag>
        <a-tag v-if="text === 2" color="#f50">不通过【驳回信息：{{ record.msg }}】</a-tag>
      </template>
      <template slot="action" slot-scope="text, record">
        <a-popconfirm
          title="确定审查通过吗?"
          @confirm="() => check(record.card, 1)"
        >
          <a-button type="primary" icon="check">通过</a-button>
        </a-popconfirm>
        <a-popover title="不通过，请填写原因" trigger="click">
          <template slot="content">
            <a-input placeholder="请输入不通过的原因" v-model="record.msg"/><br/><br/>
            <a-button type="primary" @click="checkMsg(record, 2)">
              提交
            </a-button>
          </template>
          <a-button type="danger" icon="close">不通过</a-button>
        </a-popover>
        <a-popconfirm
          title="确定删除吗?"
          @confirm="() => del(record.id)"
        >
          <a-button icon="delete">删除</a-button>
        </a-popconfirm>
        <a-button icon="setting" @click="updIsFinals(record.id)" v-if="record.isFinals == 0">获取总决赛资格</a-button>
      </template>
    </a-table>
    <ShowPlayer ref="showPlayer"/>
  </div>
</template>
<script>
import ShowPlayer from './modal/ShowPlayer'
export default {
  components: {
    ShowPlayer
  },
  data() {
    return {
      columns: [
        {
          title: '序号',
              dataIndex: 'index',
              key: 'index',
              width: 80,                    
              fixed: 'left',
              customRender: (text,record,index) => `${(this.current*1-1)*this.valData.pageSize*1 + (index+1)}`, // 关键句
        },
        {
          title: '名称',
          dataIndex: 'name',
        },
        {
          title: '学校名称',
          dataIndex: 'agencyName',
        },
        {
          title: '身份证',
          dataIndex: 'card',
        },
        {
          title: '性别',
          dataIndex: 'sex',
          scopedSlots: { customRender: 'sex' },
        },
        {
          title: '出生年月',
          dataIndex: 'birthday',
        },
        {
          title: '组别',
          dataIndex: 'title',
        },
        {
          title: '详细信息',
          dataIndex: 'combatList',
          scopedSlots: { customRender: 'combatList' },
        },
        {
          title: '审核状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      data: [],
      current: 1,
      valData: {
        pageNum: 1, 
        pageSize: 10,
        status: -1,
        keyword: '',
        agencyName: ''
      },
      total: 0
    }
  },
  mounted () {
    document.title = '道吧网 | 组委会 | 单位名单管理'
    this.findData()
  },
  methods: {
    findData () {
      this.$api.match.managePageList(this.valData).then(res => {
        if (res.status === 0) {
          this.data = res.data
          this.total = res.total
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('获取列表失败')
      })
    },
    changeStatus (e) {
      console.log(e)
      this.current = 1
      this.valData.status = e.target.value
      this.valData.pageNum = 1
      this.findData()
    },
    pageData (page) {
      this.valData.pageNum = page
      this.findData()
    },
    onSearch (e) {
      console.log(e)
      this.current = 1
      this.valData.pageNum = 1
      this.valData.keyword = e
      this.findData()
    },
    onAgencySearch (e) {
      this.current = 1
      this.valData.pageNum = 1
      this.valData.agencyName = e
      this.findData()
    },
    check (card, status) {
      this.$api.match.examineCheckMsg({card: card, status: status}).then(res => {
        if(res.status === 0){
          this.$message.success(`成功`)
          this.findData()
        }
      }).catch(err => {
          console.log(err )
      })
    },
    del (id) {
      this.$api.match.examineDelete({id: id}).then(res => {
        if(res.status === 0){
          this.$message.success(`成功`)
          this.findData()
        }
      }).catch(err => {
          console.log(err )
      })
    },
    updIsFinals (id) {
      this.$api.match.updIsFinals({id: id}).then(res => {
        if(res.status === 0){
          this.$message.success(`成功`)
          this.findData()
        }
      }).catch(err => {
          console.log(err )
      })
    },
    checkMsg (record, status) {
      if (!record.msg || record.msg === '') {
        this.$message.error(`请填写不通过的原因`)
        return
      }
      this.$api.match.examineCheckMsg({card: record.card, status: status, msg: record.msg}).then(res => {
        if(res.status === 0){
          this.$message.success(`成功`)
          this.findData()
        }
      }).catch(err => {
          console.log(err )
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.page-column {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  padding: 20px;
  .content {
    position: relative;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/organizing/Player.vue